// Module
var code = "<div class=\"bo-file\"> <div class=\"input-group\"> <div class=\"input-group-btn\"> <div class=\"btn bo-file-browse\"> <span>Browse...</span> <input type=\"file\" class=\"bo-file-input\"/> </div> </div> <input type=\"text\" value=\"{{ $ctrl.getFileNameText() }}\" class=\"form-control bo-file-filename\" readonly=\"readonly\"/> </div> </div> ";
// Exports
module.exports = code;